/**
 * Zelle eines Formularfeldes mit anschließender Validierungsmeldung (Pendant zu
 * `<ValidationMessage>`, das nur bei vorliegender Meldung etwas ausgibt).
 *
 * Seit REQ-27 §2.1 stehen die Felder in einem zweispaltigen Raster (`.iwm-form-grid`) statt
 * in Bootstrap-Spalten; die Zelle trägt deshalb `.iwm-form-field` und nicht mehr `col-lg-6`.
 */

import type { ReactNode } from 'react';

export interface FormFieldProps {
  message?: string;
  children: ReactNode;
}

export function FormField(props: FormFieldProps) {
  return (
    <div className="iwm-form-field">
      {props.children}
      {props.message === undefined ? null : (
        <div className="validation-message">{props.message}</div>
      )}
    </div>
  );
}

export default FormField;
